import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../constants";
import moment from "moment";
import { toast } from "react-toastify";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";

const ReimbursementApproval = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Reimbursement Approval"));
  }, []);

  const initialFormData = {
    ProjectID: "",
    FromDate: "",
    ToDate: "",
    AdvanceAmountUSD: 0,
    ExchangeRateUSD: 0,
    AdvanceAmountINR: 0,
    ExchangeRateINR: 0,
    AdvanceAmountBASE: 0,
    attachFile: "",
    BalanceAmountBASE: 0,
    ApprovedAmountBASE: 0,
    AdjustAmountBASE: 0,
    MonthID: "",
    ActionRemark: "",
    FileName: "",
    EmployeeID:"",
    ApplicationStatus_123: "",
    reimbursementLines: [
      {
        LineNo: 1,
        OnDate: "",
        CategoryID_168: "",
        SubCategoryID_SD168: "",
        Remark: "",
        AmountUSD: "",
        AmountINR: "",
        ApplicationStatus_123: "",
        SubCategory: "",
        VerificationRemark: "",
      },
    ],
  };
  const [formData, setFormData] = useState(initialFormData);
  const [projectList, setProjectList] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [categoryOpt, setCategoryOpt] = useState([]);
  const [descriptionOpt, setDescriptionOpt] = useState([]);
  const [projectTXNs, setProjectTXNs] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [rows, setRows] = useState([]);
  const [FileName, setFileName] = useState([]);
  const [errors, setErrors] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [payrollList, setPayrollList] = useState([]);
  const [empList, setEmpList] = useState([]);
  const [fileAttachment, SetFileAttachment] = useState([]);
  const [resumeFile, setResumeFile] = useState([]);

  useEffect(() => {
    if (id) {
      fetchTne(id);
    }
  }, []);

  const fetchTne = async (id) => {
    const response = await GetServiceCaller(
      `${API_URL}payroll/reimbursements/team-reimbursements/${id}`
    );
    if (response.status === 200) {
      const EmployeeDetail = response?.data?.data?.employee;
      const empOpt = EmployeeDetail.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setEmpList(empOpt);

      const attachment = response?.data?.data?.FilePath;
      SetFileAttachment(attachment);

      const listProject = response?.data?.data?.projectList;
      const projectOpt = listProject?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setProjectList(projectOpt);

      const status = response?.data?.data?.status;
      const statusOpt = status.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setStatusList(statusOpt?.filter(o=> o.value !=824));

      const payroll = response?.data?.data?.payrollMonths;
    
      const payrollOpt = payroll.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setPayrollList(payrollOpt);
      
      const fetchData = response?.data?.data?.tneList;
      const fetchLineData = response?.data?.data?.tneSubList;
      const Lines = fetchLineData.map((item) => ({
        ID: item.ID,
        TXNID: item.TXNID,
        LineNo: item.LineNo,
        OnDate: moment(item.OnDate).format("DD-MMM-YYYY"),
        CategoryID_168: item.CategoryID_168,
        SubCategoryID_SD168: item.SubCategoryID_SD168,
        Remark: item.Remark,
        AmountUSD: item.AmountUSD,
        ApplicationStatus_123: item.ApplicationStatus_123,
        VerificationRemark: item.VerificationRemark,
        AmountINR: item.AmountINR,
        SubCategory: item.SubCategory,
      }));

      const preselectedRows = Lines.reduce((acc, line, index) => {
        if (line.ApplicationStatus_123) {
          acc.push(index);
        }
        return acc;
      }, []);

      setSelectedRows(preselectedRows);
      
      const formDataEdit = {
        ID: fetchData?.ID,
        ProjectID: fetchData.ProjectID,
        FromDate: moment(fetchData?.FromDate).format("DD-MMM-YYYY"),
        ToDate: moment(fetchData?.ToDate).format("DD-MMM-YYYY"),
        ActionRemark: fetchData.ActionRemark,
        ApplicationStatus_123: fetchData.ApplicationStatus_123,
        AdvanceAmountUSD: fetchData.AdvanceAmountUSD,
        AdjustAmountBASE: fetchData.AdjustAmountBASE,
        AdvanceAmountINR: fetchData.AdvanceAmountINR,
        MonthID: fetchData.MonthID,
        EmployeeID:fetchData?.EmployeeID,
        FileName: fetchData?.FileName,
        ExchangeRateUSD: fetchData.ExchangeRateUSD,
        ExchangeRateINR: fetchData.ExchangeRateINR,
        reimbursementLines: Lines,
      };
      setFormData(formDataEdit);
    } else {
      console.error(
        "Failed to fetch model masters. Server responded with status:",
        response.status
      );
    }
  };

  useEffect(() => {
    if (formData?.ProjectID || formData?.EmployeeID) {
      fetchProjectDetails(formData?.ProjectID, formData?.EmployeeID);
    }
  }, [formData.ProjectID, formData?.EmployeeID]);

  const fetchProjectDetails = async (selectedValue, empId) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/reimbursements/project/currency?ProjectID=${selectedValue}&EmployeeID=${empId}`
      );

      if (response.status === 200) {
        const data = response?.data?.data;
        const projectTXNs = data.map((item) => item.TXNs);
        setProjectTXNs(projectTXNs);

        const nonINRCurrencies = data?.filter(
          (item) => item.CurrencySymbol !== "Rs."
        );
        const Symbol = nonINRCurrencies?.map((item) => item.CurrencySymbol);
        setCurrencySymbol(Symbol);
        const projectIDs = data.map((item) => item.IDs);

        setFormData((prevFormData) => ({
          ...prevFormData,
          parenttxn: projectIDs,
        }));
      }
    } catch (error) {
      console.error("Error calling API:", error);
    }
  };

  const handleInputChange = (rowIndex, field, value) => {
    const updatedReimbursementLines = [...formData.reimbursementLines];
    updatedReimbursementLines[rowIndex][field] = value;
    setFormData({ ...formData, reimbursementLines: updatedReimbursementLines });
  };

  const fetchTnE = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/reimbursements/new-TnE`
      );

      const checkdata = response?.data;
      // Project Options
      const TnE = response?.data?.data?.projectList;
      // Category Options
      const categoryList = response?.data?.data?.categoryList;
      const CategoryOptions = categoryList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setCategoryOpt(CategoryOptions);
    } catch (error) {
      console.error("Error fetching TnE:", error);
    }
  };

  useEffect(() => {
    fetchTnE();
  }, []);

  const handleFile = (file) => {
    if (file) {
      // Clear any previous error messages
      setErrors((prevErrors) => ({
        ...prevErrors,
        attachFile: "",
      }));

      // Update form data and resume file state
      setFileName(file.name);
      setFormData((prevState) => ({
        ...prevState,
        attachFile: file,
      }));
      setResumeFile(file);
    } else {
      // Set an error message if file is invalid
      setErrors((prevErrors) => ({
        ...prevErrors,
        attachFile:
          "File size should not exceed 1MB and must be a PDF or Word document.",
      }));
    }
  };

  const fetchDescriptionAPI = async (selectedValue) => {
    try {
      // Construct the URL with the selected value
      const url = `${API_URL}payroll/reimbursements/get-category-list?CategoryID=${selectedValue.value}`;

      // Call the API using the custom service
      const response = await GetServiceCaller(url);
      const description = response?.data?.data;
      const descriptionOpt = description.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDescriptionOpt(descriptionOpt);
    } catch (error) {
      console.error("Error calling API:", error);
    }
  };
  useEffect(() => {
    if (payrollList.length > 0) {
      setFormData((prev) => ({
        ...prev,
        MonthID: payrollList[0].value,
      }));
    }
  }, [payrollList]);

  const handleChange = async (event, name = null) => {
    let value;
    if (name) {
      // If it's a Select component (with selectedOption)
      const selectedOption = event;
      value = selectedOption ? selectedOption.value : "";
      setSelectedProject(selectedOption);
    } else {
      // If it's an input field
      const { name: fieldName, value: fieldValue } = event.target;
      value = fieldValue;
    }

    setFormData((prevState) => ({
      ...prevState,
      [name || event.target.name]: value,
    }));
  };

  const handleSelect1Change = async (value, rowIndex) => {
    setRows(
      rows.map((r, i) => (i === rowIndex ? { ...r, select1: value } : r))
    );

    fetchDescriptionAPI(value);

    // Update CategoryID_168 in reimbursementLines, passing only the value
    const updatedReimbursementLines = [...formData.reimbursementLines];
    updatedReimbursementLines[rowIndex] = {
      ...updatedReimbursementLines[rowIndex],
      CategoryID_168: value.value,
    };
    setFormData({ ...formData, reimbursementLines: updatedReimbursementLines });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const approvedAmount = calculateApprovedAmount();
      const updateFormData = {
        MonthID: formData.MonthID,
        ActionRemark: formData.ActionRemark,
        ApplicationStatus_123: formData.ApplicationStatus_123,
        AdjustAmountBASE: formData.AdjustAmountBASE,
        BalanceAmountBASE: BalanceAmountBASE,
        ApprovedAmountBASE: approvedAmount,
        IsDeductFromSalary: 0,
        reimbursementLines: formData.reimbursementLines.map((line) => ({
          TXNID: line.TXNID,
          LineNo: line.LineNo,
          ApplicationStatus_123: line.ApplicationStatus_123,
          VerificationRemark: line.VerificationRemark,
        })),
      };
      // Make a POST request to your API endpoint with trimmed data
      const response = await PostServiceCaller(
        `${API_URL}payroll/reimbursements/team/approve-reimbursements/${formData.ID}`,
        updateFormData,
        "post"
      );

      // Handle success
      toast.success("Data submitted successfully!");
      setFormData({});
      setTimeout(() => {
        navigate("/team-reimbursements");
      }, 2000);
    } catch (error) {
      console.error("Unexpected Error:", error);
    }
  };
  const handleCancel = () => {
    navigate("/team-reimbursements");
  };
  // new code
  const handleCheckboxChange = (index, line, checked) => {
    const newSelectedRows = checked
      ? [...selectedRows, index]
      : selectedRows.filter((row) => row !== index);
    setSelectedRows(newSelectedRows);

    setFormData((prevData) => {
      const updatedLines = prevData.reimbursementLines.map(
        (line, lineIndex) => {
          if (lineIndex === index) {
            return {
              ...line,
              ApplicationStatus_123: checked,
            };
          }
          return line;
        }
      );

      return { ...prevData, reimbursementLines: updatedLines };
    });
  };

  const calculateApprovedAmount = () => {
    if (
      !Array.isArray(selectedRows) ||
      !Array.isArray(formData?.reimbursementLines)
    ) {
      return "0.00";
    }
    return selectedRows
      .reduce((total, index) => {
        const line = formData?.reimbursementLines[index];

        if (!line) {
          return total;
        }

        const calculatedAmountINR = parseFloat(
          parseFloat(line?.AmountUSD || 0) *
            (parseFloat(formData?.ExchangeRateUSD) || 1) || 0
        ).toFixed(2);
        const amountToUse =
          calculatedAmountINR !== "0.00"
            ? parseFloat(calculatedAmountINR)
            : parseFloat(line.AmountINR || 0);

        return total + (amountToUse || 0);
      }, 0)
      .toFixed(2);
  };

  const AdvanceAmountBASE = (
    parseFloat(formData?.AdvanceAmountUSD || 0) *
      parseFloat(formData?.ExchangeRateUSD || 1) +
    parseFloat(formData?.AdvanceAmountINR || 0) *
      parseFloat(formData?.ExchangeRateINR || 1)
  ).toFixed(2);

  const reimbursementAmountUSD = formData?.reimbursementLines?.reduce(
    (sum, line) => sum + (parseFloat(line.AmountUSD) || 0),
    0
  );
  const reimbursementAmountINR = formData?.reimbursementLines?.reduce(
    (sum, line) => sum + (parseFloat(line.AmountINR) || 0),
    0
  );

  const reimbursementTotal = (
    reimbursementAmountUSD * (parseFloat(formData?.ExchangeRateUSD) || 1) +
    reimbursementAmountINR
  ).toFixed(2);

  const BalanceAmountBASE = (
    parseFloat(AdvanceAmountBASE) -
    parseFloat(calculateApprovedAmount()) -
    (formData?.AdjustAmountBASE ? parseFloat(formData?.AdjustAmountBASE) : 0)
  ).toFixed(2);

  const handleApprovedAmtChange = (e) => {
    const value = e.target.value;
    setFormData((prevState) => ({
      ...prevState,
      AdjustAmountBASE: value,
    }));
  };


  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <form onSubmit={handleSubmit}>
            <div>
              <div className="row">
                <div className="col-md-2">
                  <div class="mb-3">
                    <label for="Code" class="form-label">
                      Employee
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Employee Name"
                      disabled
                      value={empList[0]?.label || ""}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div class="mb-3">
                    <label for="Code" class="form-label">
                      Project<span className="required">*</span>
                    </label>
                    <Select
                      //   value={selectedProject}
                      value={projectList.find(
                        (opt) => opt.value === formData.ProjectID
                      )}
                      options={projectList}
                      name="ProjectID"
                      isDisabled
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div class="mb-3">
                    <label for="Code" class="form-label">
                      From Date<span className="required">*</span>
                    </label>
                    <CustomDatePicker
                      readOnly
                      value={formData.FromDate}
                      name="FromDate"
                      id="FromDate"
                      disabled={true}
                      className="form-control"
                      placeholderText="DD-MM-YYYY"
                      maxDate={new Date()}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div class="mb-3">
                    <label for="Code" class="form-label">
                      To Date<span className="required">*</span>
                    </label>
                    <CustomDatePicker
                      readOnly
                      value={formData.ToDate}
                      name="ToDate"
                      id="ToDate"
                      className="form-control"
                      placeholderText="DD-MM-YYYY"
                      maxDate={new Date()}
                    />
                  </div>
                </div>
              </div>
            </div>

            <hr class="border-2 border-top mt-0 border-black" />
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "15px",
                marginBottom: "10px",
              }}
            >
              {projectTXNs.map((txn, index) => (
                <div
                  key={index}
                  style={{
                    backgroundColor: "#00C0EF",
                    padding: "2px",
                    borderRadius: "20px",
                    color: "white",
                  }}
                >
                  <span>
                    <div dangerouslySetInnerHTML={{ __html: txn }} />
                  </span>
                </div>
              ))}
            </div>

            <Table bordered className="fixed-column-width">
              <thead id="thcolor" className="text-center">
                <tr>
                  <td>#</td>
                  <td>
                    Date<span className="required">*</span>
                  </td>
                  <td>
                    Category<span className="required">*</span>
                  </td>
                  <td>
                    Description<span className="required">*</span>
                  </td>
                  <td>Remark</td>
                  <td>
                    Amt. ({currencySymbol})<span className="required">*</span>
                  </td>
                  <td>
                    Amt. (&#8377;)<span className="required">*</span>
                  </td>
                  <td>Base Amt. (&#8377;)</td>
                  <td></td>
                  <td>Verification Remark</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="text-end">
                    <b>Advance Amt :</b>
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder="0.00"
                      disabled
                      className="form-control text-end"
                      name="AdvanceAmountUSD"
                      value={formData.AdvanceAmountUSD}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      placeholder="0.00"
                      disabled
                      className="form-control text-end"
                      name="AdvanceAmountINR"
                      value={formData.AdvanceAmountINR}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      disabled
                      placeholder="0.00"
                      className="form-control text-end"
                      name="AdvanceAmountBASE"
                      value={AdvanceAmountBASE}
                    />
                  </td>
                </tr>
                {formData?.reimbursementLines?.map((line, index) => {
                  const calculatedAmountINR = parseFloat(
                    (line?.AmountUSD || 0) *
                      (parseFloat(formData?.ExchangeRateUSD) || 1)
                  ).toFixed(2);
                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <CustomDatePicker
                          readOnly
                          value={line.OnDate}
                          name="OnDate"
                          id="OnDate"
                          className="form-control"
                          placeholderText="DD-MM-YYYY"
                        />
                      </td>
                      <td>
                        <Select
                          value={categoryOpt.find(
                            (opt) => opt.value === line.CategoryID_168
                          )}
                          options={categoryOpt}
                          onChange={(value) =>
                            handleSelect1Change(value, index, "CategoryID_168")
                          }
                          isDisabled={true}
                          name="CategoryID_168"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          disabled
                          value={line.SubCategory}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          placeholder="Remark"
                          className="form-control text-end"
                          value={line.Remark}
                          disabled
                          onChange={(e) =>
                            handleInputChange(index, "Remark", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          placeholder="0.00"
                          className="form-control text-end"
                          value={line.AmountUSD}
                          disabled
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "AmountUSD",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          placeholder="0.00"
                          className="form-control text-end"
                          value={line.AmountINR}
                          disabled
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "AmountINR",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          placeholder="0.00"
                          className="form-control text-end"
                          value={
                            calculatedAmountINR != 0.0
                              ? calculatedAmountINR
                              : line.AmountINR
                          }
                          disabled
                        />
                      </td>
                      <td>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="ApplicationStatus_123"
                          id={`flexSwitchCheckChecked-${index}`}
                          checked={line.ApplicationStatus_123}
                          onChange={(e) =>
                            handleCheckboxChange(index, line, e.target.checked)
                          }
                        />
                      </td>
                      <td>
                        <input
                          className="form-control"
                          type="text"
                          name="VerificationRemark"
                          id="VerificationRemark"
                          value={line.VerificationRemark}
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "VerificationRemark",
                              e.target.value
                            )
                          }
                        />
                      </td>
                    </tr>
                  );
                })}

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="text-end">
                    <b>Total:</b>
                  </td>
                  <td className="text-end">
                    <div>
                      <b>
                        {Array.isArray(formData?.reimbursementLines)
                          ? formData.reimbursementLines
                              .reduce(
                                (sum, line) =>
                                  sum + (parseFloat(line?.AmountUSD) || 0),
                                0
                              )
                              .toFixed(2)
                          : "0.00"}
                      </b>
                    </div>
                    <div>
                      <p>(ER:{formData?.ExchangeRateUSD})</p>
                    </div>
                  </td>
                  <td className="text-end">
                    <div>
                      <b>
                        {formData?.reimbursementLines
                          ?.reduce(
                            (sum, line) =>
                              sum + (parseFloat(line.AmountINR) || 0),
                            0
                          )
                          .toFixed(2)}
                      </b>
                    </div>
                    <div>
                      <p>(ER:{formData?.ExchangeRateINR})</p>
                    </div>
                  </td>
                  <td className="text-end">
                    <div>
                      <b>
                        {(
                          formData?.reimbursementLines?.reduce(
                            (sum, line) =>
                              sum + (parseFloat(line.AmountUSD) || 0),
                            0
                          ) *
                            (parseFloat(formData?.ExchangeRateUSD) || 1) +
                          formData?.reimbursementLines?.reduce(
                            (sum, line) =>
                              sum + (parseFloat(line.AmountINR) || 0),
                            0
                          )
                        ).toFixed(2)}
                      </b>
                    </div>
                    <div>
                      <p>(ER:1.00)</p>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td colspan="3" rowspan="3">
                    <div className="row mt-2">
                      <label className="col-sm-3 mt-2">
                        <b>Remarks</b>
                      </label>
                      <div className="col-sm-9">
                        <textarea
                          type="text"
                          class="form-control"
                          id="ActionRemark"
                          aria-describedby="ActionRemark"
                          name="ActionRemark"
                          placeholder="Remark"
                          value={formData.ActionRemark}
                          onChange={handleChange}
                        ></textarea>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <label className="col-sm-3 mt-2">
                        {/* <FileUploaderTne handleFile={handleFile} /> */}
                        <b>Attachment</b>
                      </label>
                      <div className="col-sm-9 mt-2 text-start">
                        <p>
                          <a target="_blank" href={fileAttachment}>
                            {FileName != "" ? FileName : formData?.FileName}
                          </a>
                        </p>
                      </div>
                    </div>
                  </td>
                  <td colspan="2" rowspan="2">
                    {BalanceAmountBASE >= 0 && (
                      <div className="d-flex gap-1 mt-2">
                        <div>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="IsDeductFromSalary"
                            checked={formData.IsDeductFromSalary === 1}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                IsDeductFromSalary: e.target.checked ? 1 : 0,
                              })
                            }
                          />
                        </div>
                        <label className="col-sm-12">
                          <b>Deduct From Salary</b>
                        </label>
                      </div>
                    )}
                  </td>
                  <td colspan="2" rowspan="2">
                    <div className="row">
                      <label className="col-sm-6 mt-2">
                        <b>
                          Approved Amt. (&#8377;)
                          <span className="required">*</span>
                        </b>
                      </label>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          className="form-control text-end"
                          disabled
                          name="ApprovedAmt"
                          placeholder="0.00"
                          value={calculateApprovedAmount()}
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <label className="col-sm-6 mt-2">
                        <b>Adjusted Amt. (&#8377;)</b>
                      </label>
                      <div className="col-sm-6">
                        <input
                          type="number"
                          className="form-control text-end"
                          value={formData?.AdjustAmountBASE}
                          name="AdjustAmountBASE"
                          onChange={handleApprovedAmtChange}
                          placeholder="0.00"
                        />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <label className="col-sm-6 mt-2">
                        <b>
                          Balance Amt. (&#8377;)
                          <span className="required">*</span>
                        </b>
                      </label>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          className="form-control text-end"
                          disabled
                          placeholder="0.00"
                          name="BalanceAmountBASE"
                          // value={BalanceAmountBASE}
                          value={BalanceAmountBASE < 0 ? `${Math.abs(BalanceAmountBASE)}` : `-${BalanceAmountBASE}`}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </Table>
            <div className="d-flex justify-content-between">
              <div className="row">
                <div className="d-flex gap-2">
                  <div className="col-md-8">
                    <div className="mb-3">
                      <label for="Code" class="form-label">
                        Status
                      </label>
                      <Select
                        options={statusList}
                        value={statusList.find(
                          (opt) => opt.value === formData.ApplicationStatus_123
                        )}
                        name="ApplicationStatus_123"
                        onChange={(selectedOption, action) =>
                          handleChange(selectedOption, action.name)
                        }
                      />
                    </div>
                  </div>

                  <div className="col-md-8">
                    <div className="mb-3">
                      <label for="Code" class="form-label">
                        Payroll Month
                      </label>
                      <Select
                        options={payrollList}
                        value={
                          payrollList.find(
                            (opt) => opt.value === (formData.MonthID || payrollList[0]?.value)
                          )
                        }
                        name="MonthID"
                        id="MonthID"
                        onChange={(selectedOption, action) =>
                          handleChange(selectedOption, action.name)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-5">
                <div className="col-md-12">
                  <button className="cancel-btn me-2" onClick={handleCancel}>
                    Cancel
                  </button>
                  <button type="submit" className="custom-btn">
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ReimbursementApproval;
